const DEFAULT_VENUE_LATITUDE = 48.858_222
const DEFAULT_VENUE_LONGITUDE = 2.2945

export const useGeolocation = (): {
  latitude: Ref<number | undefined>
  longitude: Ref<number | undefined>
} => {
  const latitude = ref<number | undefined>(undefined)
  const longitude = ref<number | undefined>(undefined)

  const getCurrentPositionOptions: PositionOptions = {
    enableHighAccuracy: true,
    maximumAge: 0,
    timeout: 15_000,
  }

  const getCurrentPositionSuccess = ({ coords }: GeolocationPosition) => {
    if (latitude.value && longitude.value) {
      return
    }
    latitude.value = coords.latitude
    longitude.value = coords.longitude
  }

  const getCurrentPositionError = () => {
    if (latitude.value && longitude.value) {
      return
    }
    latitude.value = DEFAULT_VENUE_LATITUDE
    longitude.value = DEFAULT_VENUE_LONGITUDE
  }

  onMounted(() => {
    if (navigator && navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        getCurrentPositionSuccess,
        getCurrentPositionError,
        getCurrentPositionOptions,
      )
    }
  })

  return {
    latitude,
    longitude,
  }
}
